import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import ProjectSelector from "./pages/ProjectSelector";
import UserPermissions from "./pages/UserPermissions";

import AracTakip from "./arac-takip/src/Main";
import FaturaTakip from "./fatura-takip/src/Main";
import KazaTakip from "./kaza-takip/src/Main";
import MazotTakip from "./mazot-takip/src/Main";
import PersonelTakip from "./personel-takip/src/Main";
import FiloTakip from "./filo-takip/src/Main";
import KontrolFormlari from "./kontrol-formlari/src/Main";
import KisiyeOzelRapor from "./kisiye-ozel-rapor/src/Main";
import HazirBeton from "./hazir-beton/src/Main";

import { AuthProvider } from "./context/AuthContext";
import "./common/security/session";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/secilen-proje" element={<ProjectSelector />} />
          <Route path="/yetki-yonetimi" element={<UserPermissions />} />

          <Route path="/arac-takip/*" element={<AracTakip />} />
          <Route path="/fatura-takip/*" element={<FaturaTakip />} />
          <Route path="/kaza-takip/*" element={<KazaTakip />} />
          <Route path="/mazot-takip/*" element={<MazotTakip />} />
          <Route path="/personel-takip/*" element={<PersonelTakip />} />
          <Route path="/kisiye-ozel-rapor/*" element={<KisiyeOzelRapor />} />
          <Route path="/filo-takip/*" element={<FiloTakip />} />
          <Route path="/kontrol-formlari/*" element={<KontrolFormlari />} />
          <Route path="/hazir-beton/*" element={<HazirBeton />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
